export default [
  {
    path: '/offline/store',
    meta: { title: '线下商城' },
    component: () => import('../../pages/offline/store.vue'),
  },
  {
    path: '/offline/cart',
    meta: { title: '购物车' },
    component: () => import('../../pages/offline/cart.vue'),
  },
  {
    path: '/offline/cartSetOrder',
    meta: { title: '确认订单' },
    component: () =>
      import(
        /* webpackChunkName: "setorder" */ '../../pages/order/cartSetOrder.vue'
      ),
  },
]
